<template>
  <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
    <b-col>
      <div class="center-form">
        <h2 class="center-align">My Account</h2>
        <b-form>
          <b-form-group id="email" label="Email address" label-for="email">
            <b-form-input
              id="email"
              v-model="form.email.value"
              :state="form.email.error.state"
              placeholder="Enter your email address"
              required
            ></b-form-input>
            <b-form-invalid-feedback :state="form.email.error.state">
              {{ form.email.error.value }}
            </b-form-invalid-feedback>
          </b-form-group>

          <div class="center-align">
            <c-button :onClick="onSubmit" variant="primary">Update</c-button>
            <br>
            <span class="success">{{ formSuccess }}</span>
            <span class="failure">{{ formFailure }}</span>
          </div>
        </b-form>

        <div v-if="loggedInWithStrava" class="center-form">
          <h4 class="center-align">Logged in with Strava</h4>
          <br>
          <b-row cols="2" cols-sm="2" cols-md="2" cols-lg="2" cols-xl="2">
            <b-col class="right-align">
              <img v-if="user.stravaDetails.profile" :src="user.stravaDetails.profile" width="100px">
              <img v-else src="https://icon-library.com/images/unknown-person-icon/unknown-person-icon-19.jpg" width="100px">
            </b-col>
            <b-col>
              <b><span>{{ user.stravaDetails.firstname }}</span></b>
              <br>
              <b><span>{{ user.stravaDetails.lastname }}</span></b>
              <br>
              <br>
              <a :href="`https://www.strava.com/athletes/${user.stravaAthleteId}`" target="_blank" class="strava">View on Strava</a>
              <br>
              <a :href="`https://www.strava.com/settings/apps`" target="_blank" class="strava">Disconnect</a>
            </b-col>
          </b-row>
        </div>
        <div v-else class="center-form">
          <h4 class="center-align">You are not logged in with Strava. Reconnect now:</h4>
          <div class="text-center">
          <c-button :onClick="onConnect" variant="transparent" :keepLoading="true">
            <img class="logo" src="../../public/connect-with-strava.png" width="200px">
          </c-button>
          </div>
          <br>
          <span class="failure">{{ failureMessage }}</span>
        </div>

        <div class="center-form text-center">
          <h6 class="center-align failure">Danger zone</h6>
          <c-button :onClick="onDelete" variant="danger">Delete my account</c-button>
          <br>
          <span class="success">{{ deleteSuccess }}</span>
          <span class="failure">{{ deleteFailure }}</span>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>

  import CButton from '@/components/Button'
  import { onLogout } from '../vue-apollo';

  export default {
    name: 'SignUp',
    components: { CButton },
    props: {

    },
    data() {
      return {
        form: {
          email: {
            value: '',
            error: {}
          }
        },
        formSuccess: '',
        formFailure: '',
        deleteSuccess: '',
        deleteFailure: '',
        failureMessage: ''
      }
    },
    created() {
      if (this.$router.currentRoute.meta.requiresAuth && (!this.$store.state.loggedUser || !this.$store.state.loggedUser.email)) this.$router.push({name: 'SignUp'})
    },
    computed: {
      user() {
        this.$set(this.form.email, 'value', this.$store.state.loggedUser.email)
        return this.$store.state.loggedUser;
      },
      loggedInWithStrava() {
        return !this.user.stravaRevokedAccess
      }
    },
    methods: {
      async onSubmit(event) {
        for (let key in this.form) {
          this.form[key].error = {}
        }
        this.formSuccess = ''
        this.formFailure = ''

        const result = await this.$apollo.mutate({
          client: 'private',
          mutation: require('@/graphql/updateUser.graphql'),
          variables: {
            email: this.form.email.value
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.formFailure = e.body.message;
            }
            if (e.body.details) {
              e.body.details.map(detail => {
                detail.path.map(path => {
                  this.$set(this.form[path], 'error', {state: false, value: detail.message})
                })
              })
            }
          }
        } else {
          this.formSuccess = "User successfully updated";

          this.$store.state.loggedUser = result.data.updateUser
        }
      },
      async onDelete(event) {
        if (confirm('Are you sure you want to delete your account? This action is irreversible')) {
          const result = await this.$apollo.mutate({
            client: 'private',
            mutation: require('@/graphql/deleteUser.graphql'),
          });

          if (result.errors) {
            const e = result;
            if (e.body) {
              if (e.body.message) {
                this.deleteFailure = e.body.message;
              }
            }
          } else {
            this.deleteSuccess = "Account successfully deleted";

            await onLogout.apply(this, [this.$apollo.provider.defaultClient])
            this.$router.push({ name: 'Home' });
          }
        }
      },
      async onConnect(event) {
        this.failureMessage = ''

        try {
          const response = await this.$http.get(process.env.VUE_APP_API_BASE_URL + "/auth")

          if (response && response.body && response.body.authUrl) {
            window.location.href = response.body.authUrl;
          } else {
            throw(new Error('Could not redirect to Strava log in page'))
          }
        } catch(e) {
          this.failureMessage = e
        }
      }
    }
  }
</script>

<style scoped>

</style>
